<template>
  <div class="mypage-ticket-today-card-section" @click="handleToggleClicked">
    <div
      class="mypage-ticket-today-card-section__toggle"
      :class="{
        'mypage-ticket-today-card-section__toggle--active':
          activeCardId === ticketType.ticketTypeId,
      }"
    >
      <p class="mypage-ticket-today-card-section__toggle-name">
        <span class="mypage-ticket-today-card-section__toggle-label">{{
          ticketType.ticketTypeName
        }}</span>
        <span class="mypage-ticket-today-card-section__toggle-icon">
          <mypage-ticket-toggle-icon-parts />
        </span>
      </p>
    </div>

    <div
      v-if="activeCardId === ticketType.ticketTypeId"
      class="mypage-ticket-today-card-section__body"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import MypageTicketToggleIconParts from '@/components/MypageTicketTodayPage/MypageTicketTodayPane/parts/MypageTicketToggleIconParts.vue'
import DigitalTicketDataTicketTypeDocument from '@/store/stores/collectionModule/documents/digitalTicket/DigitalTicketDataTicketTypeDocument'

export default defineComponent({
  name: 'MypageTicketTodayCardSection',
  components: {
    MypageTicketToggleIconParts,
  },
  props: {
    activeCardId: {
      type: String,
      default: '',
    },
    ticketType: {
      type: Object as PropType<DigitalTicketDataTicketTypeDocument>,
      required: true,
    },
  },
  setup(props, { emit }) {
    /**
     * カードの開閉が押下されたときの処理
     */
    const handleToggleClicked = () => {
      emit('onClickToggle', props.ticketType.ticketTypeId)
    }
    return {
      handleToggleClicked,
    }
  },
})
</script>

<style scoped lang="scss">
.mypage-ticket-today-card-section {
  padding: 24px;
  text-align: center;
  background-color: $white;
  border-radius: 10px;

  &__toggle {
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: center;
    width: 100%;

    &-name {
      position: relative;
      padding-right: 4px;
    }

    &-label {
      display: inline-block;
      max-width: 244px;
      font-family: $fontSignup;
      font-size: 32px;
      font-weight: 700;
      color: $black;
      letter-spacing: 0.04em;
    }

    &-icon {
      position: absolute;
      top: 50%;
      right: -30px;
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      color: $gray75;
      transform: translateY(-50%) rotate(180deg);
    }

    &--active {
      .mypage-ticket-today-card-section__toggle-icon {
        transform: translateY(-50%) rotate(0);
      }
    }
  }

  &__body {
    margin-top: 3px;
  }
}
</style>
